import * as types from '../actions/action-types';

const initialState = {
  availablePaymentOptionsList: [],
  responseStatus: '',
  clientId: '',
  form: {
    arvatoCustomerCategory: 'PERSON',
  },
  loadingOptions: false,
  isUseDeliveryAddressForBilling: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_ARVATO_FORM:
      if (typeof action.value === 'object' && state.form[action.fieldName]) {
        return {
          ...state,
          form: {
            ...state.form,
            [action.fieldName]: {
              ...state.form[action.fieldName],
              ...action.value,
            },
          },
        };
      }
  
      return {
        ...state,
        form: {
          ...state.form,
          [action.fieldName]: action.value,
        },
      };
  
    case types.UPDATE_ARVATO_LOADING:
      return {
        ...state,
        loadingOptions: !action.loadingOptions,
      };
    case types.UPDATE_ARVATO_OPTIONS:
      return {
        ...state,
        availablePaymentOptionsList: action.arvatoSession.paymentMethodCategories,
        responseStatus: action.arvatoSession.responseStatus,
        clientId: action.arvatoSession.clientId,
      };
    case types.USE_DELIVERY_ADDRESS_FOR_BILLING_ARVATO:
      return {
        ...state,
        isUseDeliveryAddressForBilling: action.isUseDeliveryAddressForBilling,
      };
  
    default:
      return state;
  }
};
